import React, {Component} from 'react';
import CSSModules from 'react-css-modules'
import container from '../../helpers/container'
import config from 'config'
import {
  ContainerDivs,
  SignupForm,
  AmazonStaffTakeActionShare,
  PlanScorecardToActionCenter,
  AmazonStaffLetters,
} from '../../components'
import Styles from './AmazonStaffThanks.css'


@CSSModules(Styles, {allowMultiple:true})
export default class AmazonStaffThanks extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  componentWillMount() {
    if (typeof window !== 'undefined') {
      window.scrollTo(0,0)
    }
  }

  render() {
    const pageTitle = 'Thanks for your support'
    //
    return (
      <div styleName='gray-bckgrnd'>
        <div styleName='page'>
          {
            container.helmet(
              pageTitle,
              config.app.description,
              config.domain + config.routes.amazon
            )
          }
          <ContainerDivs>
            <h1 styleName='large-page-title'>
              Thank you for your support!
            </h1>
            <div styleName='signup-box'>
              <div styleName='signup-box-label'>
                <div styleName='next-steps-lbl'>
                  Next steps
                </div>
                <h2>
                  Sign up for campaign updates
                </h2>
                <p>
                  We've sent a letter to Amazon management, and we'll be
                  meeting with them to ask for a more sustainable retirement
                  plan.
                </p>
              </div>
              <br/>
              <SignupForm
                url={config.amznSignupForm.url}
                id={config.amznSignupForm.id}
              />
            </div>
          <AmazonStaffLetters />
          <AmazonStaffTakeActionShare />
          </ContainerDivs>
          <PlanScorecardToActionCenter />
          <br/>
          <br/>
          <br/>
        </div>
      </div>
    )
  }
}
